// ------------------------------------
// COMPRAS RECENTES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'compras-rec-var';
    const ref2 = 'compras-rec';
    const refEvtPrefix = 'lp-evt-gatilhos-';

    // Elementos
    const $element = $('.cr-side');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref2]['compras-rec-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
      $element.data('status', value);
      if (value == '1') {
        initComprasRecentes();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'compras-rec-show', changeElShow);

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['titulo'];
      $element.find('.cr-side-titulo').html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'compras-rec-titulo', changeTitle);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['compras-rec-bg-color'];
      $element[0].style.setProperty('--compras-rec-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'compras-rec-bg-color', changeBgColor);

    // Altera a cor do título
    function changeTitColor() {
      const color = confTheme[ref]['compras-rec-tit-color'];
      $element[0].style.setProperty('--compras-rec-tit-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'compras-rec-tit-color', changeTitColor);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['compras-rec-txt-color'];
      $element[0].style.setProperty('--compras-rec-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'compras-rec-txt-color', changeTxtColor);
  }
})();

// ------------------------------------
// COMPRAS RECENTES (LISTA)
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'compras-rec-var';
    const ref2 = 'compras-rec';
    const refEvtPrefix = 'lp-evt-gatilhos-';

    // Elementos
    const $element = $('.cr-side');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['lista'];
      if ($element.length > 0) {
        $element.data('list', JSON.stringify(lista));
        initComprasRecentes();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'compras-rec-lista', changeList);
  }
})();
